export interface UserCreate {
  fullName: string;
  email: string;
}

export interface UserList {
  id: number;
  fullName: string;
  email: string;
  status: string;
  invitedAt: string;
}

export enum InvitationStatus {
  Verified = 'verified',
  Pending = 'pending',
  Expired = 'expired'
}
